"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Handle = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _toggleTheme = require("./toggleTheme");
/**
 * There are 4 horizontal states for the handle:
 * 1) unchecked + no hover: handle is far-left (on ltr screens).
 * 2) unchecked + hovered: handle scoots a bit to the "on" position.
 * 3) checked + hovered: handle scoots a bit to the "off" position, away from fully "on".
 * 4) checked + no hover: handle is fully "on" and is far-right (on ltr screens).
 *
 * The hover state options - 2 and 3 - do not apply if the Toggle is disabled.
 */
const getTransform = _ref => {
  let {
    isChecked,
    isDisabled,
    isHovered,
    size,
    themeMode
  } = _ref;
  if (isChecked && (!isHovered || isDisabled)) {
    return _toggleTheme.toggleTheme.handleTranslateX[size]["onNoHover"](themeMode);
  } else if (!isDisabled && !isChecked && isHovered) {
    return _toggleTheme.toggleTheme.handleTranslateX[size]["offHover"](themeMode);
  } else if (!isDisabled && isChecked && isHovered) {
    return _toggleTheme.toggleTheme.handleTranslateX[size]["onHover"](themeMode);
  } else {
    return _toggleTheme.toggleTheme.handleTranslateX[size]["offNoHover"](themeMode);
  }
};
const Handle = (0, _styled.default)("span")`
    position: absolute;
    background-color: ${_toggleTheme.getHandleColor};
    border-radius: 50%;
    height: ${_ref2 => {
  let {
    size,
    themeMode
  } = _ref2;
  return _toggleTheme.toggleTheme.handleSize[size](themeMode);
}}px;
    // The Slide itself has the other 2px padding to bring this to 4px of distance.
    margin-left: ${_ref3 => {
  let {
    size,
    themeMode
  } = _ref3;
  return _toggleTheme.toggleTheme.handleMargin[size](themeMode);
}}px;
    transform: ${getTransform};
    transition: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _toggleTheme.toggleTheme.motion.default(themeMode);
}};
    width: ${_ref5 => {
  let {
    size,
    themeMode
  } = _ref5;
  return _toggleTheme.toggleTheme.handleSize[size](themeMode);
}}px;
`;
exports.Handle = Handle;
//# sourceMappingURL=Handle.js.map